export default __webpack_public_path__ + "static/media/2016-Logo-A-G-E-fond-transparent.185d1145.png";